





















import { Component, Vue } from "vue-property-decorator";
import CustomLabel from "@/components/label.vue";
import WalletApi from "@/api/admin/wallet";
import { KeyValueModel, PaginationModel, VersionModel } from "@/api/types";

@Component({
  components: {
    CustomLabel,
  },
})
export default class Version extends Vue {
  data: any[] = [];
  columns=[
      {
          title:"지갑",
          dataIndex:"wallet",
          key:'wallet',
          className: 'wallet',
          width:300,
      },
      {
          title:"수량",
          dataIndex:'value',
          key:'value',
          className: 'value',
          width:200,
      },
      {
          title:"",
          dataIndex:'ex',
          key:'ex',
          className: 'ex',
      },
      
  ]

  mounted() {
    this.load();
  }

  async load() {
    const result = await WalletApi.info();
    this.data = [
      {
          key:'master',
          wallet:"마스터",
          value:result.master.toFixed(4).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
          ex:""
      },
      {
          key:'member',
          wallet:"멤버",
          value:result.memberTotal.toFixed(4).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
          ex:""
      },
      {
          key:'octet',
          wallet:"옥텟",
          value:result.octetTotal.toFixed(4).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
          ex:""
      }
    ]
  }

  // async handleOk() {
  //   this.modalLoading = true;
  //   await VersionApi.update({
  //     key: this.aosMode ? "aosVersion" : "iosVersion",
  //     value: this.newVersion,
  //   });
  //   this.modalLoading = false;
  //   this.visible = false;
  //   this.load();
  // }

  // handleCancel() {
  //   this.visible = false;
  // }
}
